import PropTypes from 'prop-types';
import {parseMessage} from 'lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemTipDirection({task, direction, maxValueOffset, onChange, disabled}) {
  const {type, tipXPositionOffset, tipYPositionOffset} = task || {};
  const labelXDirection = parseMessage('protocolEditor.taskList.pipettingProfile.tipPositionXDirection');
  const labelYDirection = parseMessage('protocolEditor.taskList.pipettingProfile.tipPositionYDirection');

  const label = direction === 'x' ? labelXDirection : labelYDirection;
  const valueOffset = direction === 'x' ? tipXPositionOffset || 0 : tipYPositionOffset || 0;

  return (
    <>
      <li>{label}</li>
      <PipettingProfileInputType.NumericTextBox
        value={valueOffset > maxValueOffset ? onChange(maxValueOffset, type) : valueOffset}
        minValue={-maxValueOffset}
        maxValue={maxValueOffset}
        onChange={(value) => onChange(value, type)}
        disabled={disabled}
      />
    </>
  );
}

PipettingItemTipDirection.propTypes = {
  task: PropTypes.object.isRequired,
  maxValueOffset: PropTypes.number,
  direction: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

PipettingItemTipDirection.defaultProps = {
  disabled: false,
  maxValueOffset: 0,
};

export default PipettingItemTipDirection;
